import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconUserKey = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M12 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.421 9c2.412 1.944 4.746 1.944 7.207.007C17.745 9.324 19 10.161 19 11.603V15c-7 0-8-.315-14-2v-1.397C5 10.15 6.275 9.311 8.421 9"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M7.387 18.058a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.07 15.346c.293 0 .577.115.787.323l1.562 1.543a1.11 1.11 0 0 1 0 1.581l-1.562 1.542c-.21.208-.494.323-.787.323h-.52c-.294 0-.578-.115-.788-.323l-.116-.114-.058-.152-.081-.21-.08.208-.057.154-.116.115c-.21.208-.495.322-.788.322h-.52a1.12 1.12 0 0 1-.787-.322l-.1-.099-.057-.127-.36-.795-.355.794-.058.128-.1.098c-.21.208-.494.323-.787.323h-.52l-.11-.005a1.12 1.12 0 0 1-.678-.318l-.1-.098-.057-.127-.358-.793-.356.792-.058.128-.1.098c-.21.208-.494.323-.786.323h-.194q-.252.374-.584.704a4.837 4.837 0 0 1-6.782 0 4.716 4.716 0 0 1 0-6.724 4.837 4.837 0 0 1 6.782 0c.225.221.42.462.59.713q3.712 0 9.038-.005z"
    />
  </NcIcon>
);
export { NcIconUserKey };
